import "./Checkbox.scss";

/**
 * Custom checkbox to allow styling, with optional id prop
 */
export const Checkbox = ({ disabled, id = "checkboxInput", ...props }) => (
  <div className={`checkbox ${disabled ? "disabled" : ""}`}>
    <input type="checkbox" id={id} {...props} />
    <label htmlFor={id} />
  </div>
);
